import { render, staticRenderFns } from "./DeadlineConfigTab.vue?vue&type=template&id=634efea8&scoped=true&"
import script from "./DeadlineConfigTab.vue?vue&type=script&lang=js&"
export * from "./DeadlineConfigTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634efea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634efea8')) {
      api.createRecord('634efea8', component.options)
    } else {
      api.reload('634efea8', component.options)
    }
    module.hot.accept("./DeadlineConfigTab.vue?vue&type=template&id=634efea8&scoped=true&", function () {
      api.rerender('634efea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/config/DeadlineConfigTab.vue"
export default component.exports